// Shapes of the admin accounts API (server/src/acct/routes/admin-schemas.ts).

export type AccountStatus = 'active' | 'grace' | 'granted' | 'expired' | 'revoked' | 'suspended' | 'none'
export type StoreEnvironment = 'Production' | 'Sandbox' | 'Xcode'

export interface AccountRow {
	id: string
	supportId: string
	status: AccountStatus
	plan: string | null
	source: 'subscription' | 'purchase' | 'grant' | null
	environment: StoreEnvironment | null
	expiresAt: string | null
	createdAt: string
	lastSeenAt: string | null
	devices: number
	/** The email it signs in with, if it has a password. */
	email: string | null
	/** Other ways it signs in: 'apple', 'game_center', … */
	signInKinds: string[]
}

export interface AccountList {
	accounts: AccountRow[]
	nextCursor: string | null
}

export interface AccountDetail {
	account: Omit<AccountRow, 'devices'> & { willRenew: boolean | null }
	purchases: {
		id: string
		type: 'subscription' | 'non_consumable'
		bundleId: string
		originalTransactionId: string
		environment: StoreEnvironment
		plan: string | null
		productId: string
		status: 'active' | 'grace' | 'expired' | 'revoked'
		expiresAt: string | null
		graceExpiresAt: string | null
		autoRenew: boolean | null
		revokedAt: string | null
		updatedAt: string
	}[]
	grants: {
		id: string
		plan: string
		source: string
		startsAt: string
		expiresAt: string | null
		note: string | null
		revokedAt: string | null
	}[]
	suspensions: { id: string; reason: string; startsAt: string; endsAt: string | null; liftedAt: string | null }[]
	links: { kind: string; value: string; createdAt: string; lastSeenAt: string }[]
	hints: { kind: string; value: string; lastSeenAt: string }[]
	devices: { platform: string; name: string | null; appVersion: string | null; boundAt: string; lastSeenAt: string }[]
	tokens: {
		prefix: string
		deviceName: string | null
		deviceId: string | null
		platform: string | null
		appVersion: string | null
		appBuild: number | null
		checkedInAt: string | null
		createdAt: string
		lastUsedAt: string | null
		revokedAt: string | null
	}[]
	events: { id: number; kind: string; actor: string; data: Record<string, unknown>; at: string }[]
}

export interface ClaimCode {
	code: string
	expiresAt: string
	link: string
}

export const LIVE: AccountStatus[] = ['active', 'grace', 'granted']
